import { useForm } from "react-hook-form";
import { useEffect } from "react";
import InputText from "./InputText";

interface QuestionnaireInputTextProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    placeholder?: string;
    multiline?: boolean;
    rows?: number;
    minRows?: number;
    maxRows?: number;
    required?: boolean;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    maxLength?: number;
    sx?: any;
    InputProps?: any;
}

/**
 * Componente de input de texto padronizado para questionários
 * Usa InputText internamente mas com interface compatível com FormItem (não usa React Hook Form)
 */
export function QuestionnaireInputText({
    value,
    onChange,
    label,
    placeholder = "Digite sua resposta...",
    multiline = false,
    rows,
    minRows,
    maxRows,
    required = false,
    error = false,
    helperText,
    disabled = false,
    maxLength,
    sx,
    InputProps,
}: QuestionnaireInputTextProps) {
    const { control, setValue } = useForm({
        defaultValues: {
            field: value || ''
        }
    });

    useEffect(() => {
        setValue('field', value || '');
    }, [value, setValue]);

    return (
        <InputText
            name="field"
            control={control}
            label={label}
            placeholder={placeholder}
            multiline={multiline}
            rows={rows}
            minRows={minRows}
            maxRows={maxRows}
            required={required}
            disabled={disabled}
            defaultValue={value || ''}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            sx={{
                width: "100%",
                ...sx,
                ...(error && {
                    "& .MuiFormHelperText-root": {
                        color: "error.main"
                    },
                    "& .MuiFilledInput-root": {
                        borderColor: "error.main"
                    }
                }),
                ...(helperText && {
                    "& .MuiFormHelperText-root": {
                        display: "block"
                    }
                })
            }}
            InputProps={{
                maxLength: maxLength,
                ...InputProps,
            }}
        />
    );
}

export default QuestionnaireInputText;
